import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import SlidingPane from 'react-sliding-pane'

import 'react-sliding-pane/dist/react-sliding-pane.css'
import './slider.css'
import constants from 'app/constants'
import { eventEmitter } from 'app/helpers'
import { useIsMobile } from 'app/hooks/useIsMobile'
import CloseIcon from 'assets/images/close.svg'

const Slider = (props) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  // Was hardcoded to false — meaning the pane always opened as the desktop
  // 65%-wide right slide-in, which on a 375px phone is mostly off-screen and
  // forces horizontal scrolling to read. Use the real breakpoint and switch
  // to a bottom-anchored full-width sheet on mobile (matches the hamburger
  // drawer + filters sheet pattern used elsewhere in the app).
  const isMobile = useIsMobile()

  const clickHandler = () => {
    setIsPaneOpen(true)
  }

  useEffect(() => {
    const handler = (data) => {
      if (props.blockType === data?.blockOpenType) {
        if (props.childComponent.props.userInfo[data.key] === data?.value) {
          setIsPaneOpen(true)
        }
      }
    }
    eventEmitter.addListener(constants.SLIDER_OPENER, handler)
  }, [props.isPaneOpen, props.childComponent])

  const handleClose = () => {
    if (props.closePanel) {
      props.closePanel()
    }
    if (props?.onClose) {
      props.onClose()
    }
    setIsPaneOpen(false)
  }

  const closeSlider = () => {
    handleClose()
  }

  return (
    <>
      <div
        className="placeholder"
        onClick={clickHandler}
        style={props.fullWidth === true ? { width: '100%' } : null}>
        {props.placeholder}
      </div>
      <SlidingPane
        isOpen={isPaneOpen}
        from={isMobile ? 'bottom' : 'right'}
        width={isMobile ? '100%' : props.width ? props.width : '65%'}
        // On mobile, cap the sheet at 90vh so it reads as a bottom sheet
        // (with the page peeking behind it) rather than a full takeover.
        // SlidingPane respects style on its outer container.
        style={isMobile ? { height: '90vh' } : undefined}
        className={`slider-custom${isMobile ? ' slider-custom--mobile' : ''}`}
        hideHeader={props.hideHeader || false}
        closeIcon={
          <div>
            <img src={CloseIcon} alt="close-icon" />
          </div>
        }
        onRequestClose={handleClose}>
        {React.isValidElement(props.childComponent)
          ? React.cloneElement(props.childComponent, { closeSlider })
          : props.childComponent}
      </SlidingPane>
    </>
  )
}

Slider.propTypes = {
  placeholder: PropTypes.node.isRequired,
  childComponent: PropTypes.node.isRequired,
  data: PropTypes.any,
  isPaneOpen: PropTypes.bool,
  blockType: PropTypes.any,
  closePanel: PropTypes.func,
  onClose: PropTypes.func,
  width: PropTypes.string,
  fullWidth: PropTypes.bool,
  hideHeader: PropTypes.bool
}

export default Slider
